<template>
  <div class="container containerForm">
    <h2 style="text-align: center">إضافة خامة جديدة</h2>
    <form @submit.prevent="addMaterial">
      <div class="form-group">
        <label for="name_ar">الاسم بالعربية</label>
        <input
          type="text"
          class="form-control"
          id="name_ar"
          v-model="materialData.name_ar"
          :class="{ 'is-invalid': errors.name_ar }"
        />
        <div v-if="errors.name_ar" class="invalid-feedback">
          {{ errors.name_ar }}
        </div>
      </div>
      <div class="form-group">
        <label for="name">الاسم بالإنجليزية</label>
        <input
          type="text"
          class="form-control"
          id="name"
          v-model="materialData.name"
          :class="{ 'is-invalid': errors.name }"
        />
        <div v-if="errors.name" class="invalid-feedback">
          {{ errors.name }}
        </div>
      </div>
      <button type="submit" class="btn btn-primary">حفظ</button>
    </form>
  </div>
</template>

<script>
import Axios from "../../../Axios";

export default {
  data() {
    return {
      materialData: {
        name_ar: "",
        name: "",
      },
      errors: {
        name_ar: null,
        name: null,
      },
    };
  },
  methods: {
    addMaterial() {
      this.resetErrors();

      if (!this.isFormValid()) return;

      const formData = new FormData();
      for (const key in this.materialData) {
        formData.append(key, this.materialData[key]);
      }

      Axios.post("/dashboard/materials", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.handleSuccessResponse(response);
        })
        .catch((error) => {
          this.handleErrorResponse(error);

        });
    },
    resetErrors() {
      this.errors = {
        name_ar: null,
        name: null,
      };
    },
    isFormValid() {
      const arabicLettersRegex = /^[\u0621-\u064A\s]+$/;
      const englishLettersRegex = /^[A-Za-z\s]+$/;

      if (!this.materialData.name_ar) {
        this.errors.name_ar = "الرجاء إدخال الاسم بالعربية";
      } else if (!arabicLettersRegex.test(this.materialData.name_ar)) {
        this.errors.name_ar = "الرجاء إدخال حروف عربية فقط";
      }

      if (!this.materialData.name) {
        this.errors.name = "الرجاء إدخال الاسم بالإنجليزية";
      } else if (!englishLettersRegex.test(this.materialData.name)) {
        this.errors.name = "الرجاء إدخال حروف إنجليزية فقط";
      }
      return true;
    },
    handleSuccessResponse(response) {
      // console.log(response.data);
      this.clearForm();
      this.$iziToast.success({
        timeout: 2000,
        message: "تم إضافة الخامة بنجاح",
        position: "bottomRight",
      });
      this.$router.push("/admin/materials");
    },
    handleErrorResponse(error) {
      // console.log(error.response);
      if (error.response && error.response.data) {
                const errorMessage = error.response.data.errors[0];
                this.$iziToast.error({
                  timeout: 5000,
                  message: errorMessage,
                  position: "bottomRight",
                });
              } else {
                this.$iziToast.error({
                  timeout: 2000,
                  message: "فشل الإضافة",
                  position: "bottomRight",
                });
              }
    },
    clearForm() {
      this.materialData = {
        name_ar: "",
        name: "",
      };
    },
  },
};
</script>